import React, { useEffect, useState } from "react";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import OurDay from "@/components/OurDay";
import Gallery from "@/components/Gallery";
import RSVP from "@/components/RSVP";
import Accommodation from "@/components/Accommodation";
import Gifts from "@/components/Gifts";
import DressCode from "@/components/DressCode";
import Footer from "@/components/Footer";
import CursorAccent from "@/components/CursorAccent";
import FloatingFlorals from "@/components/FloatingFlorals";
import { Toaster } from "sonner";

const Landing = () => {
  const [activeSection, setActiveSection] = useState("top");

  useEffect(() => {
    document.title = "Rebecca & Tom — 21st November 2026";
    const sections = document.querySelectorAll("section[id], header[id]");
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setActiveSection(entry.target.id);
          }
        });
      },
      { rootMargin: "-40% 0px -55% 0px", threshold: 0 }
    );
    sections.forEach((s) => observer.observe(s));
    return () => observer.disconnect();
  }, []);

  return (
    <div className="page">
      <CursorAccent />
      <FloatingFlorals />
      <div className="frame">
        <Nav active={activeSection} />
        <Hero />
        <OurDay />
        <Gallery />
        <RSVP />
        <Accommodation />
        <Gifts />
        <DressCode />
        <Footer />
      </div>
      <Toaster
        position="top-center"
        toastOptions={{
          style: {
            background: "#f8f3ea",
            border: "1px solid #cbb280",
            color: "#2e523f",
            fontFamily: "'Cormorant Garamond', Georgia, serif",
            fontSize: "16px",
          },
        }}
      />
    </div>
  );
};

export default Landing;
